import { render, staticRenderFns } from "./myLeavedone.vue?vue&type=template&id=b25a3544&scoped=true"
import script from "./myLeavedone.vue?vue&type=script&lang=js"
export * from "./myLeavedone.vue?vue&type=script&lang=js"
import style0 from "./myLeavedone.vue?vue&type=style&index=0&id=b25a3544&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25a3544",
  null
  
)

export default component.exports